import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import { ColorModeContext } from '../../theme';

export default function DarkModeButton() {
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);
  return (
    <IconButton
      sx={{
        padding: 0,
        width: 44,
        height: 44,
        bgcolor: 'background.default'
      }}
      onClick={colorMode.toggleColorMode}
      color="inherit"
    >
      {theme.palette.mode === 'dark' ? (
        <Icon icon="material-symbols:light-mode-outline" />
      ) : (
        <Icon icon="ic:twotone-dark-mode" width="30" height="30" color="#1B262C" />
      )}
    </IconButton>
  );
}
